var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('router-view'),_c('Manual',{ref:"manual"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }